import { faFileAlt } from "@fortawesome/free-solid-svg-icons/faFileAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import globalMU from "globalMU";
import React from "react";

const estiloProdutosComControleLote = require("./produto-controle-lote.module.scss").default;
const estiloTabela = require('../../../estilos/tabelas.module.scss').default

export type DadosProdutoControleLote = {
  CodigoFilial: number
  CodigoObjetoItemOrcamento: number
  CodigoProduto: number
  DescricaoProduto: string
  IndiceItemOrcamento: number
  QuantidadePedida: number
  QuantidadeReservada: number
  UserMessage: any
  Transforming: boolean
}

export type ProdutosControleLoteProps = {
  dadosProdutoControleLote: PagedMessageResponse<DadosProdutoControleLote>,
  onReservarLote: (codigoObjetoItemOrcamento: number) => void;
};

export const ProdutosControleLote = (props: ProdutosControleLoteProps) => {
  return (
    <>
      <div className={estiloTabela.containerRolavel}
        id="ProdutosControleLote_ContainerRolavel"
      >
        <div className={`${estiloProdutosComControleLote.tabelaControleLote} _table _w-full _border-collapse`}
          id="ProdutosControleLote_TabelaControleLote"
        >
          <div className="_table-header-group">
            <div className="_table-row">
              <div className={`_table-cell _font-bold ${estiloProdutosComControleLote.tableCellHeader}`}>Produto</div>
              <div className={`_table-cell _font-bold _text-right ${estiloProdutosComControleLote.tableCellHeader}`}>Quantidade Pedida</div>
              <div className={`_table-cell _font-bold _text-right ${estiloProdutosComControleLote.tableCellHeader}`}>Quantidade Reservada em Lote </div>
              <div className={`_table-cell _font-bold ${estiloProdutosComControleLote.tableCellHeader}`} />
            </div>
          </div>

          <div className="_table-row-group">
            {props.dadosProdutoControleLote?.Entities?.map((produto) => {
              return (
                <div key={produto.CodigoObjetoItemOrcamento} className="_table-row _cursor-pointer hover:_bg-white">
                  <div className={`_table-cell ${estiloProdutosComControleLote.tableCellBody}`}>{produto.DescricaoProduto}</div>
                  <div className={`_table-cell _text-right ${estiloProdutosComControleLote.tableCellBody}`}>{globalMU.formatarValorNumerico(produto.QuantidadePedida, 3, false)}</div>
                  <div className={`_table-cell _text-right ${estiloProdutosComControleLote.tableCellBody}`}>{globalMU.formatarValorNumerico(produto.QuantidadeReservada, 3, false)}</div>
                  <div className={`_table-cell _text-center ${estiloProdutosComControleLote.tableCellBody}`}>
                    <FontAwesomeIcon
                      cursor={"pointer"}
                      color="#3c8ac9"
                      fontSize={20}
                      icon={faFileAlt}
                      id={`ProdutosControleLote_ReservarLote_${produto.CodigoObjetoItemOrcamento}`}
                      onClick={() => props.onReservarLote(produto.CodigoObjetoItemOrcamento)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};
